import { Canvas } from '@react-three/fiber';
import { OrbitControls, useGLTF } from '@react-three/drei';
import { GLTF } from 'three-stdlib';

interface GLBModelProps {
    modelUrl: string;
}

function GLBModel({ modelUrl }: GLBModelProps) {
    const { scene } = useGLTF(modelUrl) as GLTF;
    return <primitive object={scene} />;
}

interface ModelViewerProps {
    modelUrl: string;
    width?: string;
    height?: string;
}

export default function ModelViewer({
    modelUrl,
    width = '100%',
    height = '400px',
}: ModelViewerProps) {
    return (
        <div style={{ width, height }}>
            <Canvas camera={{ position: [0, 10, 10], fov: 45 }}>
                <ambientLight intensity={0.5} />
                <directionalLight intensity={1} position={[0, 5, 5]} />
                <GLBModel modelUrl={modelUrl} />
                <OrbitControls target={[0, 0, 0]} />
            </Canvas>
        </div>
    );
}
